module.exports = __webpack_public_path__ + "static/kroll-fd38bc77f8b2b282fe2b6ad3aa26f3ee.png";